import { render, staticRenderFns } from "./CreatePostPrivacy.vue?vue&type=template&id=6526488a&"
import script from "./CreatePostPrivacy.vue?vue&type=script&lang=js&"
export * from "./CreatePostPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports